import styles from './Section.module.css'

function Section({ children }) {
    return (
        <section className={styles.sectionWrapper}>
            {children}
        </section>
    )
}

export default Section